<template>
    <Modal
        v-if="showModal && isAuthenticated()"
        :allowClose="true"
        @modal:close="closeModal"
        :maxWidth="'max-w-[540px]'"
    >
        <template #body>
            <div class="absolute top-4 left-4 text-won-maroon text-[14px] leading-[20px] font-bold">
                Limited Spots!
            </div>

            <div class="flex flex-col items-center gap-8 !font-[Inter] pb-2">
                <div>
                    <img src="/img/won.webp"/>
                </div>

                <div class="text-won-blue">
                    <h2 class="text-[30px] leading-[36px] font-bold text-center">
                        Join our FREE Land Your Dream Job Webinar
                    </h2>
                
                    <div class="mt-8 text-[14px] leading-[20px] text-won-blue">
                        <span class="font-bold">
                            Learn how to:
                        </span>

                        <ul class="mt-4 list-disc list-inside pl-2">
                            <li>Create the best resume structure to stand out to recruiters</li>
                            <li>Craft the perfect resume bullets to show your skills & experiences</li>
                            <li>Network with professionals to land interviews in 30 days</li>
                        </ul>
                    </div>

                </div>
            </div>
        </template>

        <template #actions>
            <div class="flex items-center gap-8 w-full">
                <a href="https://event.webinarjam.com/channel/wonsultingwebinar" target="_blank" class="w-full">
                    <button
                        class="w-full text-white bg-won-green rounded py-[9.5px] text-[14px] leading-[17px]"
                    >
                        Register Now
                    </button>
                </a>

                <button
                    class="p-[9.5px] w-full text-won-green rounded text-[14px] leading-[17px] border border-won-green"
                    type="button"
                    @click="closeModal"
                >
                    Close
                </button>
            </div>
        </template>
    </Modal>
</template>

<script setup>
import { setAuthState } from "../composables/auth";
import Modal from "../components/modal.vue";

const { isAuthenticated } = setAuthState();

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    closeModal: {
        type: Function,
        default: () => {}
    }
})
</script>
